import React, { useEffect, useState } from "react";
import { Routes, Route, NavLink, useLocation, useNavigate } from "react-router-dom";
import ApplicationsHome from "./pages/ApplicationsHome";
import HowlingForms from "./pages/HowlingForms";
import AdminConfig from "./pages/AdminConfig";
import "../App.css";

const logoUrl = "/howling-hills-crest.png";

export default function HowlingApp() {
  const [adminUnlocked, setAdminUnlocked] = useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const [adminError, setAdminError] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  const handleAdminSubmit = (e) => {
    e.preventDefault();
    if (adminPassword === "H&HS1M!") {
      setAdminUnlocked(true);
      setAdminError("");
      setAdminPassword("");
      navigate("/howling-hills/applications/admin");
    } else {
      setAdminError("Incorrect password.");
    }
  };

  const isAdminRoute = location.pathname.startsWith("/howling-hills/applications/admin");

  return (
    <div className="relative min-h-[calc(100vh-56px)] bg-[#070708] text-amber-50 overflow-hidden">
      {/* Background ambience similar to Academic Guild but with Apothecary-style highlights */}
      <header className="relative z-10 border-b border-[#3f2a1b]/80 bg-[radial-gradient(circle_at_top,_#2b1b10_0%,_#0a0706_55%,_#050404_100%)] shadow-[0_12px_35px_rgba(0,0,0,0.8)]">
        <div className="section flex items-center gap-4 py-4">
          <img
            src={logoUrl}
            alt="Howling Hills crest"
            className="w-16 h-16 object-contain rounded-md border border-amber-700/60 shadow-lg bg-black/40"
          />
          <div>
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-wide text-amber-100">
              Howling Hills – Applications & Forms System
            </h1>
            <p className="text-amber-200/80 text-sm">
              Central hub for staff reports, feedback, and applications.
            </p>
          </div>
          <nav className="ml-auto flex gap-2 text-sm">
            <NavLink
              to="/howling-hills/applications"
              end
              className={({ isActive }) =>
                `px-3 py-2 rounded-md border border-transparent hover:border-amber-700/60 hover:bg-amber-900/30 ${
                  isActive ? "bg-amber-900/50 border-amber-600 text-amber-100" : "text-amber-200/90"
                }`
              }
            >
              Forms
            </NavLink>
            <NavLink
              to="/howling-hills/applications/admin"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md border border-transparent hover:border-amber-700/60 hover:bg-amber-900/30 ${
                  isActive ? "bg-amber-900/50 border-amber-600 text-amber-100" : "text-amber-200/90"
                }`
              }
            >
              Admin
            </NavLink>
          </nav>
        </div>
      </header>

      <main className="section py-8 max-w-5xl mx-auto">
        <Routes>
          <Route index element={<ApplicationsHome />} />
          <Route
            path="admin"
            element={
              adminUnlocked ? (
                <AdminConfig />
              ) : (
                <div className="max-w-sm mx-auto space-y-3 border border-amber-900/70 bg-black/40 rounded-xl p-4 text-sm">
                  <h2 className="text-lg font-semibold text-amber-100">Admin access</h2>
                  <p className="text-xs text-amber-200/80">
                    This page is restricted to Howling Hills administrators. Please enter the admin password to
                    continue.
                  </p>
                  <form onSubmit={handleAdminSubmit} className="space-y-2">
                    <input
                      type="password"
                      value={adminPassword}
                      onChange={(e) => setAdminPassword(e.target.value)}
                      className="w-full bg-[#17110e] border border-[#4b3624] text-amber-100 rounded px-2 py-1 text-xs"
                      placeholder="Admin password"
                    />
                    {adminError && <p className="text-xs text-red-400">{adminError}</p>}
                    <button
                      type="submit"
                      className="inline-flex items-center justify-center rounded-md bg-amber-700 hover:bg-amber-600 text-black px-3 py-1.5 text-xs font-semibold"
                    >
                      Unlock admin
                    </button>
                  </form>
                </div>
              )
            }
          />
          <Route path=":category" element={<HowlingForms />} />
        </Routes>
      </main>
    </div>
  );
}
